import { FC } from 'react'

import clsx from 'clsx'

import { DayProps } from '../model'

import s from './styles.module.scss'

export const DisabledDay: FC<DayProps> = ({
  day,
  isCurrentDay,
  isFlexible,
  isStart,
  isEnd,
}) => {
  return (
    <div
      className={clsx(
        s.container,
        isCurrentDay && s.currentDay,
        isFlexible && s.flexible,
        {
          [s.start]: isStart,
          [s.end]: isEnd,
        },
      )}
    >
      <p className={clsx('bold-14')}>{day}</p>
    </div>
  )
}
